import axios from "axios";
import { environment } from "../../environments/environment";
import { ApiError, IInvoiceLoginResponse, ILogin, ILoginFormValues, IMFAVerifyResponse } from "../../models/ILogin";
import { BACKEND_URL } from "../../constants/backendUrl";
import EncryptionService from "../EncryptionService";
export class LoginService {
	private static URL: any = environment.authApiUrl;

	public static login(data: ILogin) {
		// let UserURL: any = `${this.URL}/Auth/Login`;
		const requestData: ILogin = {
			...data,
			password: EncryptionService.encryptPassword(data.password)
		};
		let UserURL: any = `${this.URL}/${BACKEND_URL.login}`;

		return axios.post<any>(UserURL, requestData);
	}

	public static logout() {
		let UserURL: any = `${this.URL}/${BACKEND_URL.logout}`;
		const config = {
			headers: { Authorization: `Bearer ${sessionStorage.getItem("Token")}` }
		};
		return axios.get<any>(UserURL, config);
	}

	public static updatetoken() {
		let UserURL: any = `${this.URL}/${BACKEND_URL.updateToken}`;
		const config = {
			headers: { Authorization: `Bearer ${sessionStorage.getItem("Token")}` }
		};
		return axios.get<any>(UserURL, config);
	}

	public static async invoiceLogin(data: ILoginFormValues): Promise<IInvoiceLoginResponse> {
		try {
			// const UserURL: string = "https://localhost:20048/v1/invoicing/sign-in";
			const UserURL: string = `${this.URL}/v1/invoicing/sign-in`;
			const response = await axios.post<IInvoiceLoginResponse>(UserURL, data);
			return response.data;
		} catch (error: any) {
			const status = error?.response?.status;

			let apiError: ApiError = {
				success: false,
				message: "Something went wrong during login",
				data: error?.response?.data?.data || null
			};

			if (status === 429) {
				apiError.message = "Too many login attempts. Please try again after some time.";
			} else if (error?.response?.data?.message) {
				apiError.message = error.response.data.message;
			} else if (!error?.response) {
				apiError.message = "Network error. Please check your internet connection.";
			}

			throw apiError;
		}
	}

	public static async iValtVerify(token: string): Promise<IMFAVerifyResponse> {
		try {
			const safeToken = encodeURIComponent(token);
			const UserURL = `${this.URL}/v1/invoicing/mfa?mfaToken=${safeToken}`;
			// const UserURL: string = "https://localhost:20048/v1/invoicing/mfa?mfaToken=" + safeToken;
			const response = await axios.post<IMFAVerifyResponse>(UserURL);
			return response.data;
		} catch (error: any) {
			throw new Error(error?.response?.data?.errorMessage || error?.message || "Something went wrong during invoice registration");
		}
	}
}
